import { render, staticRenderFns } from "./category.vue?vue&type=template&id=dc94742a&scoped=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"
import style0 from "./category.vue?vue&type=style&index=0&id=dc94742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc94742a",
  null
  
)

export default component.exports